import { render, staticRenderFns } from "./SideMenuItem.vue?vue&type=template&id=05318975&scoped=true&"
import script from "./SideMenuItem.vue?vue&type=script&lang=js&"
export * from "./SideMenuItem.vue?vue&type=script&lang=js&"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=05318975&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05318975",
  null
  
)

export default component.exports